import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class ChargeCodeMappingController {
  constructor($rootScope, $uibModal, $state, $http, toastr) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.chargeCodes = [];
    this.qbServices = [];
    this.qbExpenseAccounts = [];
    this.qbIncomeAccounts = [];

    this.loadChargeCodes();
    this.loadQbServices();
    this.loadQbExpenseAccounts();
    this.loadQbIncomeAccounts();
  }

  loadChargeCodes() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/admin/chargecodes", {withCredentials: true}).then(function (success) {
      self.chargeCodes = success.data;
    });
  }

  loadQbServices() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/services", {withCredentials: true}).then(function (success) {
      self.qbServices = success.data;
    });
  }

  loadQbExpenseAccounts() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/accounts?type=Expense", {withCredentials: true}).then(function (success) {
      self.qbExpenseAccounts = success.data;
    });
  }

  loadQbIncomeAccounts() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/accounts?type=Income", {withCredentials: true}).then(function (success) {
      self.qbIncomeAccounts = success.data;
    });
  }


  getExpenseAccountName(id) {
    let x = _.find(this.qbExpenseAccounts, { 'id': id});
    console.log(id + ": " + x);
    if(x) {
      return x.acctNum + " - " + x.name;
    }
  }

  getIncomeAccountName(id) {
    let x = _.find(this.qbIncomeAccounts, { 'id': id});
    if(x) {
      return x.acctNum + " - " + x.name;
    }
  }

  getServiceName(id) {
    let x = _.find(this.qbServices, { 'id': id});
    if(x) {
      return x.name;
    }
  }


  updateChargeCodeDetails(id, parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/chargecodes/"+id, obj, {withCredentials: true}).then(function (success) {
      self.loadChargeCodes();
      self.toastr.success("Successfully Paired Charge Code With Quickbooks!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could Not Pair Charge Code With Quickbooks.", "ERROR");
    });
  }



}

export default ChargeCodeMappingController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/charge-code-mapping/charge-code-mapping.controller.js